/* eslint-disable react/react-in-jsx-scope */
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import DashboardWebApi from "../services/DashboardWebApi";

const PageNotAccessible = () => {
  const isAuthenticated = DashboardWebApi.IsAuthenticated();

  if (!isAuthenticated) {
    return (
      <Container maxWidth={false}>
        <Alert sx={{ border: 1, padding: 2, mx: 2, marginTop: 5 }}  severity="info">Page not accesible. Please try logging in again.</Alert>
      </Container>
    )
  }
}

export default PageNotAccessible;
